import { render, staticRenderFns } from "./tenantDeleteConformationDialog.vue?vue&type=template&id=59d1a208&scoped=true&"
import script from "./tenantDeleteConformationDialog.vue?vue&type=script&lang=js&"
export * from "./tenantDeleteConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1a208",
  null
  
)

export default component.exports